define([
	"require",
	"jquery",
	"domReady",
	"wcs.context"
], function(require, $, domReady, context) {
	var JS_PATH_PREFIX = "wcs/util/i18n/messages_";
	var DEFAULT_LOCALE = "en_US";
	
	function getDefaultLocale() {
		return DEFAULT_LOCALE;
	}
	domReady(function(){
		var MODULE_PATH = JS_PATH_PREFIX + context.getLocale(); 
		if (context.getLocale() != DEFAULT_LOCALE) require([MODULE_PATH]);
	});
	
	return {
		getDefaultLocale: getDefaultLocale
	};
});